import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, X as XIcon } from "@phosphor-icons/react";
import SantriSelect from "@/components/SantriSelect";
import RowActions from "@/components/RowActions";
import { queueOp, flushQueue } from "@/lib/offlineSync";

export default function Pelanggaran() {
  const [items, setItems] = useState([]);
  const [types, setTypes] = useState([]);
  const [form, setForm] = useState({ santri: null, jenis_id: "", tanggal: new Date().toISOString().slice(0, 10), keterangan: "", poin_override: "" });
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const { data } = await api.get("/pelanggaran", { params: { tanggal_from: from || undefined, tanggal_to: to || undefined } });
    setItems(data);
  };
  useEffect(() => { api.get("/master/pelanggaran").then((r) => setTypes(r.data)); }, []);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [from, to]);

  const submit = async (e) => {
    e.preventDefault();
    const nis = form.santri?.nis;
    if (!nis) { toast.error("Pilih santri terlebih dahulu"); return; }
    const payload = { nis, jenis_id: form.jenis_id, tanggal: form.tanggal, keterangan: form.keterangan };
    if (form.poin_override) payload.poin_override = Number(form.poin_override);
    try {
      if (navigator.onLine) {
        await api.post("/pelanggaran", payload);
        toast.success("Pelanggaran dicatat");
      } else {
        await queueOp({ op: "create", path: "/pelanggaran", payload });
        toast.success("Offline — antre untuk sync");
      }
      setForm({ ...form, santri: null, keterangan: "", poin_override: "" });
      load(); flushQueue(api);
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };

  const saveEdit = async () => {
    try {
      const payload = { jenis_id: editing.jenis_id, tanggal: editing.tanggal, keterangan: editing.keterangan };
      if (editing.poin_override !== undefined && editing.poin_override !== "" && editing.poin_override !== null) {
        payload.poin_override = Number(editing.poin_override);
      }
      await api.put(`/pelanggaran/${editing.id}`, payload);
      toast.success("Pelanggaran diperbarui"); setEditing(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };

  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">Divisi Kedisiplinan</div>
        <h1 className="font-display text-3xl font-bold text-[#064E3B]">Pelanggaran Santri</h1>
      </div>

      <form onSubmit={submit} className="imsyaf-card p-5 grid md:grid-cols-5 gap-3">
        <div className="md:col-span-2"><label className="text-xs">Santri (cari nama / kamar) *</label>
          <SantriSelect value={form.santri} onChange={(s) => setForm({ ...form, santri: s })} testid="pel-santri" /></div>
        <div className="md:col-span-2"><label className="text-xs">Jenis Pelanggaran *</label>
          <select required className="imsyaf-input" value={form.jenis_id} onChange={(e) => setForm({ ...form, jenis_id: e.target.value })} data-testid="pel-jenis">
            <option value="">Pilih…</option>
            {types.map((t) => <option key={t.id} value={t.id}>{t.nama} ({t.poin} poin)</option>)}
          </select></div>
        <div><label className="text-xs">Tanggal</label><input type="date" className="imsyaf-input" value={form.tanggal} onChange={(e) => setForm({ ...form, tanggal: e.target.value })} /></div>
        <div><label className="text-xs">Poin (opsional override)</label><input type="number" className="imsyaf-input" value={form.poin_override} onChange={(e) => setForm({ ...form, poin_override: e.target.value })} /></div>
        <div className="md:col-span-5"><label className="text-xs">Keterangan</label><input className="imsyaf-input" value={form.keterangan} onChange={(e) => setForm({ ...form, keterangan: e.target.value })} /></div>
        <div className="md:col-span-5"><button className="imsyaf-btn-primary" data-testid="pel-save-btn"><Plus size={16} /> Simpan Pelanggaran</button></div>
      </form>

      <div className="imsyaf-card p-4 flex flex-wrap items-end gap-3">
        <div><label className="text-xs">Dari</label><input type="date" className="imsyaf-input" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
        <div><label className="text-xs">Sampai</label><input type="date" className="imsyaf-input" value={to} onChange={(e) => setTo(e.target.value)} /></div>
      </div>

      <div className="imsyaf-card overflow-hidden">
        <table className="w-full text-sm zebra">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-4 py-2">Tanggal</th><th className="text-left px-4 py-2">NIS</th><th className="text-left px-4 py-2">Nama</th>
            <th className="text-left px-4 py-2">Jenis</th><th className="text-left px-4 py-2">Poin</th><th className="text-left px-4 py-2">Keterangan</th>
            <th className="text-right px-4 py-2">Aksi</th>
          </tr></thead>
          <tbody>{items.map((p) => (
            <tr key={p.id} className="border-t border-slate-100" data-testid={`pel-row-${p.id}`}>
              <td className="px-4 py-2">{p.tanggal}</td>
              <td className="px-4 py-2 font-mono">{p.santri_nis}</td><td className="px-4 py-2">{p.santri_nama}</td>
              <td className="px-4 py-2">{p.jenis_nama}</td><td className="px-4 py-2 font-bold text-red-700">{p.poin}</td>
              <td className="px-4 py-2 text-slate-500">{p.keterangan || "-"}</td>
              <td className="px-4 py-2 text-right">
                <RowActions testid={`pel-${p.id}`}
                  onEdit={() => setEditing({ ...p, poin_override: p.poin })}
                  onDelete={async () => { await api.delete(`/pelanggaran/${p.id}`); toast.success("Dihapus"); load(); }}
                  confirmText="Hapus pelanggaran ini?" />
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-slate-400">Belum ada pelanggaran.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" data-testid="edit-pel-modal">
          <div className="bg-white rounded-xl p-6 max-w-md w-full space-y-3 relative">
            <button onClick={() => setEditing(null)} className="absolute top-3 right-3 text-slate-400 hover:text-slate-700"><XIcon size={18}/></button>
            <h3 className="font-display text-lg font-bold text-[#064E3B]">Edit Pelanggaran — {editing.santri_nama}</h3>
            <div><label className="text-xs">Jenis</label>
              <select className="imsyaf-input" value={editing.jenis_id} onChange={(e) => setEditing({ ...editing, jenis_id: e.target.value })}>
                {types.map((t) => <option key={t.id} value={t.id}>{t.nama} ({t.poin} poin)</option>)}
              </select></div>
            <div><label className="text-xs">Tanggal</label>
              <input type="date" className="imsyaf-input" value={editing.tanggal} onChange={(e) => setEditing({ ...editing, tanggal: e.target.value })}/></div>
            <div><label className="text-xs">Poin</label>
              <input type="number" className="imsyaf-input" value={editing.poin_override ?? ""} onChange={(e) => setEditing({ ...editing, poin_override: e.target.value })}/></div>
            <div><label className="text-xs">Keterangan</label>
              <input className="imsyaf-input" value={editing.keterangan || ""} onChange={(e) => setEditing({ ...editing, keterangan: e.target.value })}/></div>
            <div className="flex justify-end gap-2 pt-2">
              <button onClick={() => setEditing(null)} className="imsyaf-btn-outline">Batal</button>
              <button onClick={saveEdit} className="imsyaf-btn-primary" data-testid="edit-pel-save">Simpan</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
